import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { List, Map, OrderedSet } from 'immutable';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { connect } from 'react-redux';
import { change as cff } from 'redux-form/immutable';
import styled from 'styled-components';
import { Field, MuiRadioGroup, formValueSelector } from '../../../common/form';
import { Card } from '../../../common/styles/layout';
import { Button } from '../../../common/components';
import { getSystemEnumList } from '../../../reducer';
import QuestionTemplateCustomizer from './question_template_customizer';
import theme from '../../../common/theme';
import ScoringAnswerSync from './scoring_answer_sync';

const CloseButton = styled(Button)`
  float: right;
  margin: -10px -20px 0 0;
  padding: ${theme.padding.small};
  border-bottom: 0;
`;

const StandardQuestionView = ({ choice, changeFormField, importanceTypes, isIncluded }) => {
  if (isIncluded !== 'Yes') {
    return null;
  }
  const onDelete = () => changeFormField('jobForm', `surveyQuestionAttributes.${choice.get('id')}.isIncluded`, 'No');
  const importanceChoices = importanceTypes.filterNot((i) => i.get('excludeFromVisibleChoices'));
  return (
    <Grid item xs={10}>
      <Card>
        <CloseButton buttonType="text" onClick={onDelete}>
          &times;
        </CloseButton>
        <Grid item justify="flex-start" alignItems="center" spacing={2}>
          <FormGroup row style={{ alignItems: 'center' }}>
            <QuestionTemplateCustomizer
              namespace={`surveyQuestionAttributes.${choice.get('id')}.extra.questionPlaceholders`}
              question={choice.get('setupQuestion')}
              placeholders={choice.getIn(['extra', 'setupQuestionPlaceholders'])}
            />
          </FormGroup>
        </Grid>
        {choice.getIn(['scoringPolicy', 'scoringAnswerSource']) && <ScoringAnswerSync choice={choice} />}
        <Grid item xs={10}>
          <Field name={`surveyQuestionAttributes.${choice.get('id')}.questionImportanceType`} component={MuiRadioGroup}>
            <FormGroup row>
              {importanceChoices.map((importance) => (
                <FormControlLabel
                  key={importance.get('slug')}
                  value={importance.get('slug')}
                  control={<Radio color="primary" />}
                  label={importance.get('label')}
                  labelPlacement="end"
                />
              ))}
            </FormGroup>
          </Field>
        </Grid>
      </Card>
    </Grid>
  );
};
StandardQuestionView.propTypes = {
  choice: PropTypes.instanceOf(Map).isRequired,
  changeFormField: PropTypes.func.isRequired,
  importanceTypes: PropTypes.instanceOf(OrderedSet).isRequired,
  isIncluded: PropTypes.string,
};
StandardQuestionView.defaultProps = {
  isIncluded: 'No',
};

const StandardQuestionRenderer = connect(
  (state, { choice }) => {
    const isIncluded = formValueSelector('jobForm')(state, `surveyQuestionAttributes.${choice.get('id')}.isIncluded`);
    return {
      importanceTypes: getSystemEnumList(state, 'QuestionImportanceType'),
      isIncluded,
    };
  },
  { changeFormField: cff },
)(StandardQuestionView);

const AddQuestionBar = ({ choices }) => (
  <div style={{ margin: '0 -10px' }}>
    {choices.map((choice) => (
      <Field
        key={choice.get('id')}
        name={`surveyQuestionAttributes.${choice.get('id')}.isIncluded`}
        component={({ input: { value, onChange } }) => {
          if (value === 'Yes') {
            return null;
          }
          if (value !== 'No') {
            onChange('No');
          }
          return (
            <Button
              style={{ margin: '10px', border: `solid 1px ${theme.color.blue}` }}
              key={choice.get('id')}
              buttonType="secondary-outline"
              size="small"
              type="button"
              onClick={() => onChange('Yes')}
            >
              {`+ ${choice.get('title')}`}
            </Button>
          );
        }}
      />
    ))}
  </div>
);
AddQuestionBar.propTypes = {
  choices: PropTypes.instanceOf(List).isRequired,
};

const StandardSection = ({ choices }) => (
  <Fragment>
    <AddQuestionBar choices={choices} />
    {choices.map((choice) => (
      <StandardQuestionRenderer key={choice.get('id')} choice={choice} />
    ))}
  </Fragment>
);
StandardSection.propTypes = {
  choices: PropTypes.instanceOf(List).isRequired,
};

export default StandardSection;
